import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styles from './form-debug.styl'

export default class FormDebug extends Component {
  static propTypes = {
    values: PropTypes.object,
    errors: PropTypes.object,
  }

  state = {
    displayDebugger: false,
    isShown: false,
  }

  render() {
    return this.state.isShown ? (
      <div className={styles.formDebug}>
        {this.state.displayDebugger && <div className={styles.data}>
          <div className="row">
            <div className="col-xs-6">
              <p className={styles.caption}>Values</p>
              <pre className={styles.values}>{JSON.stringify(this.props.values, null, 2)}</pre>
            </div>
            <div className="col-xs-6">
              <p className={styles.caption}>Errors</p>
              <pre className={styles.values}>{JSON.stringify(this.props.errors, null, 2)}</pre>
            </div>
          </div>
        </div>}
        <div className={styles.button}>
          <button type='button' onClick={() => this.setState({ displayDebugger: !this.state.displayDebugger })}>
            form debug
          </button>
        </div>
      </div>
    ) : <div />
  }
}
